<tr *ngFor="let number of counter(rows)">
    <td *ngFor="let val of counter(columns)"><p-skeleton height="2rem"></p-skeleton></td>
</tr>